<template>
    <div>
        <v-stepper vertical v-model="step" class="px-md-10 px-0">

            <v-stepper-step step="1">
                مرحله ۱
                <small>نوع سفارش</small>
            </v-stepper-step>
            <v-stepper-content step="1">
                <h5 class="pb-5 text-center"> {{ pageTitle }}</h5>
                <div class="m-3">
                    <v-text-field id="nid" outlined
                                  :error-messages="nameErr"
                                  v-model="data.name"
                                  dense
                                  maxLength="50"
                                  counter="50"
                                  :rules="this.$rules.requiredString"
                                  label="نام مجموعه شما"
                                  append-icon="mdi-domain"/>
                </div>
                <div class="m-3">
                    <v-text-field outlined
                                  v-model="data.domain"
                                  dense
                                  hint="terminalads.com"
                                  :rules="urlRules"
                                  @keypress="justEnglish($event)"
                                  maxLength="50"
                                  counter="50"
                                  label="نام دامنه شما"
                                  append-icon="mdi-domain"/>
                </div>
                <v-btn class="submit-btn" @click="step1Validate">
                    ادامه
                    <span class="fa fa-arrow-left mr-1"></span>
                </v-btn>

            </v-stepper-content>

            <v-stepper-step step="2">
                مرحله ۲
                <small>اطلاعات اولیه سفارش</small>
            </v-stepper-step>
            <v-stepper-content step="2">
                <div class="mt-2">

                    <div>
                        <site-value v-if="data.type==='design'" v-model="data.quality"></site-value>
                        <v-text-field
                                outlined
                                label="میزان هزینه"
                                dense
                                placeholder="لطفا حدود مبلغی که برای طراحی سایت خود در نظر دارید را وارد کنید."
                                v-model="main_price"
                                clearable
                                maxLength="11"
                                type="text"
                                @keypress="allowOnlyNumbers"
                                clear-icon="mdi-close-circle"
                                prepend-inner-icon="fa fa-pencil-alt"
                        >
                        </v-text-field>
                        <v-radio-group class="mt-0 ot-0" row v-model="data.preferred_currency">
                            <v-radio
                                    label="ریال"
                                    value="Rial"
                            ></v-radio>
                            <v-radio
                                    label="تومان"
                                    value="Toman"
                            ></v-radio>
                        </v-radio-group>
                        <key-value v-if="data.type==='design'" :value="data.recommended_sites"
                                   main-label="سایت های پیشنهادی"
                                   key-label="لینک سایت"
                                   value-label="توضیحات"></key-value>
                    </div>
                    <div v-if="data.type==='seo'">
                        <key-value :value="data.rivals"
                                   main-label="سایت های رقبا"
                                   key-label="لینک سایت"
                                   value-label="توضیحات"></key-value>
                        <prop-selector
                                v-model="data.key_words"
                                :label="'کلمات کلیدی مد نظرتان را بنویسید و کلید Enter را فشار دهید'"></prop-selector>
                    </div>
                    <div v-if="data.type==='support'">
                        <key-value :value="data.recommended_sites"
                                   main-label="سایت های پیشنهادی"
                                   key-label="لینک سایت"
                                   value-label="توضیحات"></key-value>
                    </div>
                </div>
                <v-btn class="submit-btn" @click="step2Validate">
                    ادامه
                    <span class="fa fa-arrow-left mr-1"></span>
                </v-btn>
                <v-btn class="mx-4 btn-refund" @click="step = 1">
                    <span class="fa fa-arrow-right mr-1"></span>
                    بازگشت
                </v-btn>
            </v-stepper-content>

            <v-stepper-step step="3">
                مرحله ۳
                <small>مشخصات سایت</small>
            </v-stepper-step>
            <v-stepper-content step="3">
                <div class="mt-2" v-if="step===3">
                    <site-select v-model="data.site_type"></site-select>
                    <programming-select class="mt-5" v-model="data.programming_language"></programming-select>
                    <div>
                        <p class="mt-5">آیا نیاز به درج مقاله نیز دارید؟</p>
                        <v-select
                                outlined
                                label="مقاله"
                                :items="articles"
                                @change="needsArtcile($event)"
                                item-text="text"
                                item-value="value"
                                dense
                                clear-icon="mdi-close-circle"
                                prepend-inner-icon="fa fa-pencil-alt"
                        ></v-select>
                        <v-text-field v-if="articleDesc"
                                      outlined
                                      class="mt-2"
                                      v-model="data.article_count"
                                      type="number"
                                      @keypress="allowOnlyNumbers"
                                      dense
                                      label="تعداد مقاله موردنیاز"
                                      prepend-inner-icon="fa fa-pencil-alt"/>
                    </div>
                    <div>
                        <p class="mt-5">آیا اطلاعات مجموعه و محصولات را مایلید خودتان وارد کنید؟</p>
                        <v-select
                                outlined
                                label="وارد کردن اطلاعات"
                                :items="articles"
                                @change="enterMyself($event)"
                                item-text="text"
                                item-value="value"
                                dense
                                clear-icon="mdi-close-circle"
                                prepend-inner-icon="fa fa-pencil-alt"
                        ></v-select>
                        <v-text-field v-if="enterMine"
                                      outlined
                                      class="mt-2"
                                      v-model="data.data_by"
                                      type="number"
                                      @keypress="allowOnlyNumbers"
                                      dense
                                      label="تعداد محصول"
                                      prepend-inner-icon="fa fa-pencil-alt"/>
                    </div>
                    <div v-if="data.type==='seo'">
                        <p class="mt-5">آیا سایت شما نیاز به بازسازی طراحی یا بازنگری توسط متخصصان ما دارد؟</p>
                        <v-select
                                outlined
                                label="باز طراحی/اصلاح طراحی"
                                :items="articles"
                                @change="redesign($event)"
                                item-text="text"
                                item-value="value"
                                dense
                                clear-icon="mdi-close-circle"
                                prepend-inner-icon="fa fa-pencil-alt"
                        ></v-select>
                    </div>
                    <div v-if="data.type==='seo'">
                        <v-select
                                outlined
                                label="نوع سئو"
                                :items="seoType"
                                v-model="data.seo_type"
                                item-text="text"
                                item-value="value"
                                dense
                                class="mt-5"
                                clear-icon="mdi-close-circle"
                                prepend-inner-icon="fa fa-pencil-alt"
                        ></v-select>
                    </div>
                    <key-value v-if="data.type==='design'" :value="data.menu"
                               main-label="منوهای موردنیاز"
                               key-label="نام منو"
                               value-label="توضیحات"></key-value>
                </div>
                <v-btn class="submit-btn" @click="step3Validate">
                    ادامه
                    <span class="fa fa-arrow-left mr-1"></span>
                </v-btn>
                <v-btn class="mx-4 btn-refund" @click="step = 2">
                    <span class="fa fa-arrow-right mr-1"></span>
                    بازگشت
                </v-btn>
            </v-stepper-content>

            <v-stepper-step step="4">
                مرحله ۴
                <small>توضیحات</small>
            </v-stepper-step>
            <v-stepper-content step="4">
                <div class="mt-1">
                    <div class="">
                        <span class="text-center pb-2">لطفا برای بارگذاری عکس  بر روی کادرپایین کلیک کنید</span>
                    </div>
                    <v-file-input
                            v-model="data.file"
                            label=" بارگذاری عکس "
                            outlined
                            accept="image/png, image/jpeg,image/jpg, image/bmp"
                            placeholder="عکس موردنظر خود را بارگذاری کنید."
                            hint="حداکثر حجم هر عکس مورد نظر می‌تواند 2مگابابت باشد."
                            prepend-inner-icon="mdi-camera"
                            clearable
                            small-chips
                            clear-icon="mdi-close-circle-outline"
                            prepend-icon=""
                            dense
                            multiple
                            class="mt-1 pt-1"
                    >
                    </v-file-input>

                    <div class="mb-2">
                        <span class="text-center pb-2">لطفا توضیحات تکمیلی خود در مورد نیازتان را برای متخصصان ما یادداشت نمایید، تا بتوانیم به بهترین شکل ممکن درخواست شما را بررسی و پاسخ دهیم.</span>
                    </div>
                    <ckeditor :editor="editor.editor" v-model="data.description"
                              :config="editor.editorConfig"></ckeditor>
                    <v-text-field outlined
                                  class="mt-2 inputPrice"
                                  v-if='data.type=== "support"'
                                  v-model="data.support_time"
                                  type="number"
                                  @keypress="allowOnlyNumbers"
                                  dense
                                  :rules="rules"
                                  label="مدت زمان نیاز به پشتیبانی(ماه)"
                                  append-icon="mdi-date"/>
                </div>
                <v-btn :loading="loading" class="submit-btn mt-5" @click="submit">
                    <span class="fa fa-save mr-1"></span>
                    ثبت سفارش
                </v-btn>
                <v-btn class="mx-4 mt-5 btn-refund" @click="step = 3">
                    <span class="fa fa-arrow-right mr-1"></span>
                    بازگشت
                </v-btn>
            </v-stepper-content>

        </v-stepper>
    </div>
</template>

<script>
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import CKEditorUploadAdapterPlugin from "../../../core/plugins/CKEditorUploadFileAdapter";
import {createFormData} from "../../../Utilities/FormRequestHelper";

export default {
    name: "stepper",
    data() {
        return {
            step: 1,
            marker: true,
            editor: {
                editor: ClassicEditor,
                editorConfig: {
                    language: 'fa',
                    contentsLangDirection: 'rtl',
                    extraPlugins: [CKEditorUploadAdapterPlugin],
                }
            },
            mainPrice: "",
            dialogPayment: false,
            designs: false,
            payDialogInfo: {},
            articles: [
                {text: 'بله', value: 'true'},
                {text: 'خیر', value: 'false'},
            ],
            seoType: [
                {text: 'پایه', value: 'basic'},
                {text: 'برندینگ', value: 'branding'},
                {text: 'حرفه ای', value: 'professional'},
                {text: 'داخلی', value: 'internal'},
                {text: 'خارجی', value: 'external'},
                {text: 'تکنیکال', value: 'technical'},
                {text: 'تولید محتوا', value: 'Contentـproduction'},
            ],
            payableTransaction: null,
            selectedRows: [],
            paymentLoading: false,
            data: {
                name: null,
                preferred_currency: 'Rial',
                domain: null,
                seo_type: null,
                redesign: null,
                data_by: null,
                article_count: '',
                user_price: '',
                key_words: [],
                type: null,
                menu: [],
                quality: null,
                recommended_sites: [],
                rivals: [],
                programming_language: null,
                site_type: null,
                file: [],
                support_time: null,
                description: '',
            },
            orderTypes: [
                {key: 'design', keyAlias: 'طراحی سایت', icon: '/media/site/aparat.png'},
                {key: 'support', keyAlias: 'پشتیبانی سایت', icon: '/media/site/aparat.png'},
                {key: 'seo', keyAlias: 'سئو سایت', icon: '/media/site/aparat.png'},
            ],
            errors: [],
            dialog: false,
            loading: false,
            rules: [
                v => !!v || 'وارد کردن این فیلد الزامی است',
            ],
            urlRules: [
                (value) => this.isURL(value) || "دامنه سایت باید بصورت https://terminalads.com یا terminalads.com وارد شود. ",
            ],
            errorMsg: '',
            nameErr: '',
            pageTitle: '',
            userWallet: [],
            dialogInfo: null,
            tab: null,
            items: [
                'سفارش ها',
                'ثبت سفارش جدید',
            ],
            userInfo: {},
            statusBadge: '',
            userValid: true,
            isRejected: false,
            isPending: false,
            articleDesc: false,
            enterMine: false,
            userInfoGot: false
        }
    },
    methods: {
        isURL(str) {
            var regex = new RegExp("^(http[s]?:\\/\\/(www\\.)?|ftp:\\/\\/(www\\.)?|www\\.){1}([0-9A-Za-z-\\.@:%_\+~#=]+)+((\\.[a-zA-Z]{2,3})+)(/(.)*)?(\\?(.)*)?");
            var without_regex = new RegExp("^([0-9A-Za-z-\\.@:%_\+~#=]+)+((\\.[a-zA-Z]{2,3})+)(/(.)*)?(\\?(.)*)?");
            if (regex.test(str) || without_regex.test(str)) {
                return true
            } else {
                return false;
            }
        },
        justEnglish(str) {
            const p = /^(\w|\.|\d)$/i;
            if (p.test(str.key)) {
                return str.key
            } else
                str.preventDefault();
        },
        paymentDialog(data) {
            this.payDialogInfo = data
            this.dialogPayment = true
        },
        step1Validate() {
            if (!this.data.name || !this.data.type || (!this.data.domain && this.$route.name === 'support.index') || (!this.data.domain && this.$route.name === 'seo.index')) {
                this.$toast.error('لطفا اطلاعات اولیه سفارش خود را تکمیل کنید!')
                return
            }
            this.step = 2
        },
        step2Validate() {
            if (this.data.type === 'design' && !this.data.quality || (this.data.key_words.length <= 0 && this.$route.name === 'seo.index')) {
                this.$toast.error('لطفا اطلاعات اولیه سفارش خود را تکمیل کنید!')
                return
            }
            this.step = 3
        },
        step3Validate() {
            if (!this.data.site_type || !this.data.programming_language) {
                this.$toast.error('لطفا اطلاعات اولیه سفارش خود را تکمیل کنید!')
                return
            }
            this.step = 4
        },
        submit() {
            if ((this.$route.name === 'support.index' && !this.data.description) || (this.$route.name === 'support.index' && !this.data.support_time)) {
                this.$toast.error('تمامی فیلدهای نمایش داده شده اجباری می باشند.');
                return;

            } else {
                this.loading=true;
                this.requestApiPost(`site`, createFormData(this.data))
                    .then((res) => {
                        if (res.status && res.status === 201) {
                            this.loading=false;
                            this.$emit('eventname', 1)
                            this.$toast.success('با موفقیت ثبت شد.');
                        } else {
                            this.loading=false;
                            this.$toast.warning('لطفا مجددا تلاش کنید')
                        }
                    })
                    .catch((e) => {
                        this.loading=false;
                        this.$toast.error(Object.values(e.response.data.errors).map((x) => {
                            return x.join('\n');
                        }).join(''));

                        this.errors = e.response.data.errors
                    })
                    .finally(() => {
                        this.loading=false;
                        this.$modal.hideLoading();
                    })
            }
        },
        pay(transactionId) {
            if (this.payDialogInfo.payments.type === 'final') {

                this.requestApiPost(`payment/${this.payDialogInfo.id}/pay`, {transaction_id: this.payDialogInfo.payments.transactions[0].id})
                    .then(response => {
                        this.$toast.success('با موفقیت پرداخت شد!')
                        this.getSites()
                        this.dialogPayment = false
                    }).catch(({res}) => {
                    this.loading = false
                    this.$toast.error(res.data.message)
                })


            } else {
                this.requestApiPost(`payment/${this.payDialogInfo.id}/pay`, {transaction_id: transactionId})
                    .then(response => {
                        this.$toast.success('با موفقیت پرداخت شد!')
                        this.getSites()
                        this.dialogPayment = false
                    }).catch(({res}) => {
                    this.loading = false
                    this.$toast.error(res.data.message)
                })

            }
        },
        getSites(url = this.url, params = this.tableProps) {
            this.$modal.showLoading();
            this.requestApiGet(url, params).then(response => {
                this.userInfo = response.data;
            }).finally(() => {
                this.$modal.hideLoading();
                if (!this.userInfoGot) {
                    this.getUserInfo();
                }
            })
        },
        edit(data) {
            this.$router.push({name: 'admin.user.edit', params: {id: data.id}})
        },
        information(data) {
            this.$router.push({name: 'admin.users.information', params: {id: data.id}})
        },
        checkRoutes() {
            if (this.$route.name === 'site.index') {
                this.data.type = 'design';
                this.pageTitle = this.orderTypes[0].keyAlias;
            } else if (this.$route.name === 'support.index') {
                this.data.type = 'support';
                this.pageTitle = this.orderTypes[1].keyAlias;
            } else {
                this.data.type = 'seo';
                this.pageTitle = this.orderTypes[2].keyAlias;
            }

        },
        needsArtcile(value) {
            if (value === 'true') {
                this.articleDesc = true;
            } else this.articleDesc = false;
        },
        enterMyself(value) {
            if (value === 'true') {
                this.enterMine = true;
            } else this.enterMine = false;
        },
        redesign(value) {
            if (value === 'true') {
                this.data.redesign = 1;
            } else this.data.redesign = 0;
        },
        changeUnit() {
            this.marker = !this.marker;
            if (this.marker) {
                this.data.preferred_currency = 'Rial'
            } else this.data.preferred_currency = 'Toman'
        }
    },
    watch: {
        'data.name': function (value) {
            var regex = /^[a-zA-Z]+$/;
            if (value > 3 && !value.match(regex)) {
                this.nameErr = 'نام مجموعه نمیتواند تنها شامل اعداد باشد.'
            } else
                this.nameErr = '';
        },
        articleDesc(value) {
            if (!value)
                this.data.article_count = ''
        },
        enterMine(value) {
            if (!value)
                this.data.productCount = ''
        },
        isNumberKey: function (evt) {
            let persianChars = ['۰', '۱', '۲', '۳', '۴', '۵', '۶', '۷', '۸', '۹']
            evt = (evt) ? evt : window.event;
            let charCode = (evt.which) ? evt.which : evt.keyCode;
            if (((charCode > 31 && (charCode < 48 || charCode > 57)) && (persianChars.indexOf(evt.key) === -1))) {
                evt.preventDefault();
            } else {
                return true;
            }
        },
    },
    computed: {
        main_price: {
            get() {
                return this.$options.filters.currency(this.data.user_price)
            },
            set(value) {
                this.data.user_price = value.replaceAll(',', '')
            }
        },
    },
    mounted() {
        this.checkRoutes();
    }
}
</script>

<style scoped>

</style>